import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LogoutIcon from '@mui/icons-material/Logout';
import SecurityIcon from '@mui/icons-material/Security';
import { ProfileDropdownItemType } from '@webbyx/mui';

export const useUserDropdownMenuItems = (props?: {
  onLogout: () => void;
  authUser: any;
}): ProfileDropdownItemType[] => {
  // =============== HOOKS

  // =============== RETURN
  return [
    {
      key: 'company',
      title: props?.authUser?.customer?.customer_name,
      icon: <ApartmentIcon />,
      disabled: true,
    },
    'divider',
    {
      key: 'account',
      title: 'My Account',
      icon: <AccountCircleIcon />,
      url: '/settings?tab=account',
    },
    {
      key: 'security',
      title: 'Account Security',
      icon: <SecurityIcon />,
      url: '/settings?tab=security',
    },
    {
      key: 'information',
      title: 'Business Information',
      icon: <BusinessCenterIcon />,
      url: '/settings?tab=business',
    },
    {
      key: 'bank',
      title: 'Bank',
      icon: <AccountBalanceIcon />,
      url: '/settings?tab=bank',
    },
    {
      key: 'faq',
      title: 'FAQ',
      icon: <ContactSupportIcon />,
      url: '/faq',
    },
    'divider',
    {
      key: 'logout',
      title: 'Logout',
      icon: <LogoutIcon />,
      onClick: props?.onLogout,
    },
  ];
};
